import React from 'react';
import { Redirect, useParams, useLocation } from 'react-router-dom';
import { ROUTES } from '../../constants/routes';

function QuestionByIdPage() {
  const { id } = useParams<{ id: string }>();
  const location = useLocation();

  if (!/^\d+$/.test(id)) {
    return <Redirect to={ROUTES.COURSES} />;
  }

  return <Redirect to={`${ROUTES.NEW_QUESTIONS}/${id}${location.search}`} />;
}

export default QuestionByIdPage;
